// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PXrV","footer":"styles_footer__1c01Y","passCodeTooltip":"styles_passCodeTooltip___jpyp"};